<template>
  <v-container class="login-container" fluid>
    <v-row class="fill-height" no-gutters>
      <!-- Left Section with Background Image -->
      <v-col cols="12" md="6" lg="8" class="hidden-sm-and-down">
        <div class="background-image">
          <div class="overlay">
            <div class="welcome-content">
             <v-img
              :src="logo"
              contain
              class="logo mb-3"
            />
              <h1 class="welcome-title">Account Verification</h1>
              <p class="welcome-description">
                Enter the verification code sent to your email/phone
              </p>
            </div>
          </div>
        </div>
      </v-col>

      <!-- Right Section - Form -->
      <v-col cols="12" md="6" lg="4" class="form-section">
        <v-card class="auth-card" flat>
          <v-card-title class="justify-center pt-10 pb-5">
            <!-- <v-img
              src=":src="logo""
              max-width="287"
              contain
              class="logo"
            /> -->
          </v-card-title>

          <v-card-text class="px-8">
            <div class="text-center mb-8">
              <h2 class="app-bold-font mb-2">Verification Code</h2>
              <p class="text--secondary mb-6">
                We've sent a 4-digit code to your registered email/phone
              </p>
              
              <CodeInput
                class="verification-input"
                v-model="verifycode"
                @change="onChange"
                @complete="onComplete"
                :loading="loading"
              />

              <v-alert
                v-if="errorMessage"
                type="error"
                dense
                outlined
                class="mt-6"
              >
                {{ errorMessage }}
              </v-alert>
            </div>

            <v-btn
              block
              x-large
              rounded
              color="#0A5B8A"
              @click="confirmCode"
              :loading="loading"
              :disabled="verifycode.length !== 4"
              dark
            >
              Verify Code
            </v-btn>

            <div class="text-center mt-4">
              <v-btn
                text
                color="primary"
                class="text-none"
                @click="goBack"
              >
                <v-icon left small>mdi-arrow-left</v-icon>
                Back
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import CodeInput from "vue-pincode-input";

export default {
  components: { CodeInput },
  data() {
    return {
      verifycode: "",
      loading: false,
      errorMessage: null
    };
  },
    computed: {
    logo() {
      // resolve the logo file based on .env string
      return require(`@/assets/${process.env.VUE_APP_LOGO}`);
    }
  },
  methods: {
    ...mapActions({
      onSubmitVerificationCode: "auth/onSubmitVerificationCode"
    }),
    onComplete() {
      this.confirmCode();
    },
    confirmCode() {
      if (this.loading || this.verifycode.length !== 4) return;
      
      this.loading = true;
      this.errorMessage = null;
      
      this.onSubmitVerificationCode({
        ...this.$route.params,
        otp: this.verifycode
      })
        .then(() => {
          this.$router.push({
            name: "reset-password",
            params: { ...this.$route.params, otp: this.verifycode }
          });
        })
        .catch(error => {
          this.loading = false;
          this.errorMessage = error.response?.data?.message || error.message;
        });
    },
    onChange() {
      this.errorMessage = null;
    },
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.login-container {
  height: 100vh;
  padding: 0;
}

.background-image {
  background-image: url(../../assets/bg_login.jpg);
  background-size: cover;
  background-position: center;
  height: 100%;
  position: relative;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(10, 91, 138, 0.7) 0%,
    rgba(36, 163, 154, 0.6) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
}

.welcome-content {
  max-width: 80%;
  color: white;
  text-align: center;
}

.welcome-title {
  font-family: "Poppins-Bold";
  font-size: 3rem;
  line-height: 1.2;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.welcome-description {
  font-family: "Poppins-Medium";
  font-size: 1.2rem;
  opacity: 0.9;
}

.form-section {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f9fa;
}

.auth-card {
  width: 100%;
  max-width: 450px;
  border-radius: 16px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08) !important;
  background-color: white;
}

.logo {
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.verification-input {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

/* Custom styling for the code input */
.verification-input >>> .pincode-input-container {
  display: flex;
  justify-content: center;
}

.verification-input >>> .pincode-input-text {
  width: 50px !important;
  height: 60px !important;
  margin: 0 8px;
  font-size: 1.5rem;
  text-align: center;
  border-radius: 8px;
  border: 1px solid #ddd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.verification-input >>> .pincode-input-text:focus {
  border-color: #0A5B8A;
  box-shadow: 0 0 0 2px rgba(10, 91, 138, 0.2);
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .welcome-title {
    font-size: 2.5rem;
  }
  
  .welcome-description {
    font-size: 1rem;
  }
}

@media (max-width: 600px) {
  .auth-card {
    border-radius: 0 !important;
    box-shadow: none !important;
  }
  
  .form-section {
    padding: 0;
  }
  
  .verification-input >>> .pincode-input-text {
    width: 45px !important;
    height: 55px !important;
    margin: 0 5px;
  }
}
</style>